import { Button, Tooltip } from "@dit/core-frontend"
import React from "react"
import { buttonProps } from "./buttonProps"
import { INSERT_TABLE_OF_CONTENT } from "../../plugins/TableOfContentPlugin"
import { TableOfContentIcon } from "../../theme/editorIcons"
import { memo } from "react"

export const TableOfContentButton = memo(({ isEditable, activeEditor }) => {
  return (
    <Tooltip content="Сформировать оглавление">
      <Button
        {...buttonProps}
        kind="borderless"
        disabled={!isEditable}
        onClick={() => {
          activeEditor.dispatchCommand(INSERT_TABLE_OF_CONTENT, undefined)
        }}
      >
        <TableOfContentIcon />
      </Button>
    </Tooltip>
  )
})
TableOfContentButton.displayName = "TableOfContentButton"
